module.exports = __webpack_public_path__ + "media/images/writer/user_upgrade_achievement_mailer/rank_up-255a506eb7e0a310b57593ffd194ca08.png";